<template>
    <transition name="fade" mode="out-in">
        <div v-if="infoModalBrasil.show" >
            <div class="modal" :style="{ top: `${ infoModalBrasil.posicao.top }px` }">
                <div class="modal-content">
                    <div class="modal-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" @click="closeModal">
                            <path fill="#8FC74A" fill-rule="evenodd" d="M9.73 8.5L17 15.77 15.77 17 8.5 9.73 1.23 17 0 15.77 7.27 8.5 0 1.23 1.23 0 8.5 7.27 15.77 0 17 1.23z" />
                        </svg>
                    </div>
                    <h2>{{ infoModalBrasil.titulo }}</h2>
                    <div class="box">
                        <!-- <p>{{ infoModalBrasil.desc }}</p> -->
                    </div>
                    <ul>
                        <li v-for="item in infoModalBrasil.info" :key="item.idTipo" :style="{ 'background-image': 'url(' + url + item.idTipo + '.svg' + ')' }">
                            <p>{{ item.nome }} <span>{{ item.qtd }}</span> </p>
                        </li>
                    </ul>

                    <span @click="alterarSetor(infoModalBrasil.rota)" class="btn-green">Detalhes das Intervenções<span class="arrow-right"></span></span>
                </div>
            </div>
            <div id="overlay"></div>
        </div>

    </transition>
</template>


<script>
import { mapState, mapActions } from 'vuex'


export default {

props: ['options'],
    data () {
        return {
            url: '/img/mapas/icons/',
            dados: null
        }
    },

    computed: {
        ...mapState({
            infoModalBrasil: (state) => state.Layout.infoModalBrasil
        }),

        styles: () => {
            return this.$store.state.Layout.infoModalBrasil
        }
    },

    methods: {
        ...mapActions({
            showModal: 'Layout/enviarInformacaoModalBrasil',
            setSetorAtivo: 'Layout/setSetorAtivo'
        }),

        alterarSetor (setor) {
            const data = {
                id: setor
            }

            this.setSetorAtivo(data)
        },

        closeModal () {
            let payload = [
                 {
                id: null,
                titulo: null,
                desc: null,
                estagio: null,
                valor: null,
                icons: null,
                show: false,
                posicao: {
                    top: null,
                    left: null,
					right: null,
					bottom: null
                },
				assets: {
					x: null,
					y: null,
					height: null,
					width: null
				}
              }
            ]

            this.showModal(payload)
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    width: 251px;
    border-radius: 2px;
    background-color: #f6f6f6;
    position: absolute;
    right: 0;
    left: 0;
    padding: 24px 0px 40px 0px;
    box-shadow: 1px 4px 2px 0px #e4d0d0;
    @include media_tablet() {
        margin: 0 auto;
        width: 100%;
        z-index: 3;
    }

    .modal-content {
        position: relative;
    }

 .modal-header {
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;

    svg {
        cursor: pointer;
        @media (max-height:  900px) and (min-width: 1200px)   {
            height: 15px;
            width: 15px;
        }
    }
 }

  h3 {
    color: #565656;
    font-size: 13px;
    margin-bottom: 6px;
  }

  h2 {
      font-size: 14px;
      color: #3994d0;
      font-weight: bold;
      padding: 0 27px;
      margin-bottom: 15px;
  }

  p {
      font-size: 14px;
      color: #565656;
      margin-bottom: 9px;
  }

    .box {
        margin-bottom: 20px;
        padding: 0 27px;
    }


  .content-box {
      display: flex;
      padding: 0 27px;
      .box-01 {
          width: 50%;
      }
      .box-02 {
          width: 50%;
      }
  }

  ul {
    padding: 0 10px;
    margin-top: 9px;
      li {
        width: 100%;
        height: 35px;
        background-repeat: no-repeat;
        background-size: 10%;
        background-position: 20px 0px;
        padding: 0px 0 0 55px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;


        p {
            color: #565656;
            font-size: 13px;
            @include media_tablet() {
                margin-left: 15px;
            }

        }

        span {
            margin-left: 10px;
            font-weight: bold;
        }
      }
  }

  .btn-green {
    background-color: #8fc74a;
    border: none;
    border-radius: 30px;
    padding: 15px 30px;
    color: #fff;
    font-size: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    .arrow-right {
        background-image: url(../assets/seta-direita-branca.svg);
        background-repeat: no-repeat;
        background-position: left;
        width: 10px;
        height: 14px;
        display: block;
        position: absolute;
        right: 10px;
        top: 15px;
    }
  }
}

#overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color:rgba(216, 216, 216, 0.5);;
  z-index: 2;
  cursor: pointer;
  @include media_tablet() {
        display: block;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
